import { render, staticRenderFns } from "./deleteChainSupplierCatalog.vue?vue&type=template&id=29939a94"
import script from "./deleteChainSupplierCatalog.vue?vue&type=script&lang=js"
export * from "./deleteChainSupplierCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports